import styled from 'styled-components';

export const Container = styled.div`
  .title {
    color: ${(props) => props.theme.$primary_green};
    font-size: 24px;
    line-height: 36px;
    font-weight: 700;
  }

  .subtitle {
    color: ${(props) => props.theme.$black};
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  .subtitle-2 {
    color: ${(props) => props.theme.$dark_charcoal};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }

  .card-value {
    background: ${(props) => props.theme.$primary_green};
  }

  .value {
    color: ${(props) => props.theme.$white};
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
    margin-bottom: 0px;
    margin-top: 22px;
  }
  .value-info {
    color: ${(props) => props.theme.$white};
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }
`;
